import { useCallback, useTransition } from 'react'

import { fetchAddressByCep, ViaCepResponse } from '@/api/cep'

const CEP_LENGTH = 8

interface UseCepSearchOptions {
  onSuccess?: (data: ViaCepResponse) => void
  onError?: (error: Error) => void
}

export const useCepSearch = ({ onSuccess, onError }: UseCepSearchOptions = {}) => {
  const [isPending, startTransition] = useTransition()

  const searchCep = useCallback(
    (rawValue: string) => {
      const cleanCep = rawValue.replace(/\D/g, '')

      if (cleanCep.length !== CEP_LENGTH) return

      startTransition(async () => {
        try {
          const data = await fetchAddressByCep(cleanCep)
          onSuccess?.(data)
        } catch (error) {
          onError?.(error as Error)
        }
      })
    },
    [onSuccess, onError]
  )

  return { searchCep, isPending }
}
